import React from 'react';
import styles from '../Operations.module.css';

interface SFTHComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const SFTH: SFTHComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
       The Training Hours performance driver reflects how much time you invest in training and developing your team. Giving our customer-facing associates the training they need to be successful is a fundamental component of continuing our standing as the most helpful hardware stores on the planet. Proper training also provides a path to increased sales. Stores that train more, sell more.
      </div>

      <div className={styles.sectionTitle}>
       Supporting Details
      </div>

      <div className={styles.sectionContent}>
       Total Training Hours for active customer-facing associates divided by the total active customer-facing associates = average Training Hours. Stores must meet or exceed the target once in the calendar year to achieve Platinum or Pinnacle status. Note: &quot;Customer-facing associates&quot; are those who are selected by you in Ace Learning Place. Each role that has the customer-facing field selected will count toward the Training Hours calculation.
      </div>

       <div className={styles.sectionTitle}>
       Drill Down
      </div>

      <div className={styles.sectionContent}>
      Clicking your score will open up a grid of active users for your store and each individual users Training Hours.
      </div>

      <div className={styles.sectionTitle}>
       Learn More
      </div>

      <div className={styles.sectionContent}>
      See ACENET - Growth Drivers for more information{' '}
        <a
          href="https://acenet.aceservices.com/growth-drivers/retail-growth-strategy/higher-ground/higher-ground-performance-driver-summary/performance-driver-training-hours"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          https://acenet.aceservices.com/growth-drivers/retail-growth-strategy/higher-ground/higher-ground-performance-driver-summary/performance-driver-training-hours
        </a>
      </div>
    </div>
  );
};


SFTH.title = 'Training Hours';
SFTH.actionTitle = 'training hours by associate';
SFTH.actionHyperlink = 'dynamicURL:WFC:current';
export default SFTH;

